import { authServerInstance, gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const stateDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/state`
    );

    return response.data.map((item) => ({
      key: item.sttId,
      text: item.sttStateName,
      value: item.sttId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const stateCountryDropdown = async (countryId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/state/dropdown/${countryId}`
    );

    return response.data.map((item) => ({
      key: item.sttId,
      text: item.sttStateName,
      value: item.sttId,
    }));
  } catch (e) {
    console.error(e);
  }
};



export const stateByCountryAndStartsWith = async ({ searchText, id }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/state/namestartswith/${id}`,
      searchText
    );

    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const stateName = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/state/name/${id}`
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const stateCreate = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/state/create`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateStates = async (id, data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/state/update/${id}`,
      data
    );
  } catch (e) {
    console.error(e);
  }
};

export const getByIdState = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/state/get-by/${id}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
